<template>
  <div class="" v-if="show">
    <ed-radio
      :fieldLabel='`${allocationLabel} Allocation`'
      :options='options'
      v-model='selectedType'
      track-by='id'
      name='allocation'
      @click="setAllocationType"
      :error='error'
      :helptip-body='helptipBody'
      helptipHeader=''
    >
        <ed-select
          slot="additionalInfo_1"
          :placeholder='`Select ${allocationLabel}`'
          :options='allocations'
          label='value'
          track-by='key'
          v-model='allocation'
          @select='allocationSelected($event)'
          :error='displayAllocationError'
          :helptip-body='displayAllocationError && `Please select a ${allocationLabel} Allocation` || ""'
          helptipHeader=''
          name='cc_alocation'
          >
        </ed-select>
        <p slot='additionalInfo_2' class="small">
          <em>After the invoice is scanned, you will be notified to add the {{allocationLabel}}s before it can be approved.</em>
        </p>
    </ed-radio>
  </div>
</template>

<script>
  import { Eved, EventBus } from '@/event-bus'

  export default {
    props: {
      model: Object,
      error: Boolean,
      helptipBody: String,
      displayAllocationError: Boolean
    },
    data() {
      return {
        allocationLabel: '',
        options: [],
        allocations: [],
        type: '',
        allocationModel: {
          costCenters: [],
          pairs: []
        },
        allocation: {},
        selectedType: ['allocationSelectedType'],
        slotName: '',
        allocationSectionModel: {
          hasAllocationSection: this.show,
          isAllocationSelected: false,
          hasAllocationForScan: false
        }
      }
    },
    created() {
      EventBus.$off(Eved.I2P.UPDATE_ALLOCATION_MODEL)
      EventBus.$on(Eved.I2P.UPDATE_ALLOCATION_MODEL, e => {
        this.bindAllocations(e.data)
      })

      EventBus.$off(Eved.I2P.INIT_ALLOCATION_MODEL)
      EventBus.$on(Eved.I2P.INIT_ALLOCATION_MODEL, e => {
        this.initAllocations(e.data)
      })
    },
    computed: {
      show() {
        return this.allocations !== null && this.allocations !== undefined && this.allocations.length > 1
      }
    },
    methods: {
      setAllocationType(e) {
        switch (this.selectedType[0]) {
          case '1':
            this.allocationSectionModel.hasAllocationForScan = true
            break
          case '2':
            this.allocationModel.costCenters = []
            this.allocationModel.pairs = []
            this.allocation = {}
            this.allocationSectionModel.hasAllocationForScan = false
            break
        }
        this.allocationSectionModel.hasAllocationSection = true
        this.allocationSectionModel.isAllocationSelected = true
        this.$emit('allocationForScanSelected', this.allocationSectionModel)
      },

      initAllocations(data) {
        this.allocation = {}
        this.allocationModel.costCenters = []
        this.allocationModel.pairs = []

        if (data.type === 'Pairs') {
          this.bindPairLabels()
        } else {
          this.bindCostCenterLabels()
        }

        this.allocationSectionModel.hasAllocationSection = true
        this.allocationSectionModel.isAllocationSelected = true

        if (data.hasMultipleAllocation) {
          this.allocationSectionModel.hasAllocationForScan = false
          this.selectedType = [this.options[1].id]
        } else if (data.selectedOption) {
          this.allocationSectionModel.hasAllocationForScan = true
          this.selectedType = [this.options[0].id]

          this.allocationSelected({
            key: data.selectedOption.Key,
            value: data.selectedOption.Value,
            additionalNo: data.AdditionalNo
          })
        }

        this.$emit('allocationForScanSelected', this.allocationSectionModel)
      },

      bindAllocations(data) {
        this.allocation = {}
        let costCenters = data.costCenters
        let pairs = data.pairs
        if (costCenters !== null && costCenters !== undefined && costCenters.length > 1) {
          this.allocations = costCenters
          this.bindCostCenterLabels()
          this.allocationSectionModel.hasAllocationSection = true
          this.allocationSectionModel.isAllocationSelected = false
        } else if (pairs !== null && pairs !== undefined && pairs.length > 1) {
          this.allocations = pairs
          this.bindPairLabels()
          this.allocationSectionModel.hasAllocationSection = true
          this.allocationSectionModel.isAllocationSelected = false
        } else {
          this.allocations = []
          this.allocationForScanSelected = false
          this.allocationSectionModel.hasAllocationSection = false
          this.allocationSectionModel.isAllocationSelected = false
        }
        this.$emit('allocationForScanSelected', this.allocationSectionModel)
      },

      bindCostCenterLabels() {
        this.type = 'CostCenter'
        this.allocationLabel = 'Cost Center'
        this.options = [{label: 'One Cost Center', id: '1', status: false, additionalInfo: true, slotName: 'additionalInfo_1'},
                        {label: 'Multiple Cost Centers', id: '2', status: false, additionalInfo: true, slotName: 'additionalInfo_2'}]
      },

      bindPairLabels() {
        this.type = 'Pairs'
        this.allocationLabel = 'Business Unit & Cost Center'
        this.options = [{label: 'One Business Unit & Cost Center', id: '1', status: false, additionalInfo: true, slotName: 'additionalInfo_1'},
                      {label: 'Multiple Business Unit & Cost Centers ', id: '2', status: false, additionalInfo: true, slotName: 'additionalInfo_2'}]
      },

      allocationSelected(e) {
        this.allocation = e
        switch (this.type) {
          case 'CostCenter':
            this.allocationModel.costCenters = [e]
            break
          case 'Pairs':
            this.allocationModel.pairs = [e]
            break
        }
        EventBus.$emit(Eved.I2P.ADD_CC_FOR_SCAN, this.allocationModel)
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/I2P/AllocationSection.vue